import { useCallback, useRef } from 'react';
import {
  registerScreenCaptureTarget,
  type ScreenCaptureSnapshot
} from '@pages/MediaViewer/AssetViewer/WebsiteCard/screen-capture-coordinator';

export interface ScreenCaptureController {
  snapshot: (signal: AbortSignal) => Promise<ScreenCaptureSnapshot>;
  onStop: (callback: () => void) => () => void;
  setRegionOverride: (element: HTMLElement | null) => void;
}

export function useScreenCapture() {
  const initialized = useRef<ScreenCaptureController | null>(null);
  const initialize = useCallback(
    (captureTarget: HTMLElement, initSignal: AbortSignal) => {
      if (initialized.current) return initialized.current;

      const target = registerScreenCaptureTarget(captureTarget, initSignal);
      const controller = {
        snapshot: target.snapshot,
        onStop: target.onStop,
        setRegionOverride: target.setRegionOverride
      };
      initialized.current = controller;

      initSignal.addEventListener(
        'abort',
        () => {
          if (initialized.current === controller) initialized.current = null;
        },
        { once: true }
      );
      return controller;
    },
    []
  );
  return initialize;
}
